import type { Locale } from "@/types";

const NUMBER_LOCALE: Record<Locale, string> = {
  ru: "ru-RU",
  uz: "uz-Latn-UZ",
  en: "en-US",
};

export function formatUzs(amount: number, locale: Locale = "ru"): string {
  const formatted = new Intl.NumberFormat(NUMBER_LOCALE[locale] ?? "ru-RU", {
    maximumFractionDigits: 0,
  }).format(amount);
  return `${formatted} UZS`;
}

export function formatMinutesLeft(targetIso: string, now: Date = new Date()): number {
  const diffMs = new Date(targetIso).getTime() - now.getTime();
  return Math.max(0, Math.round(diffMs / 60000));
}

export function formatOrderDate(iso: string, locale: Locale = "ru"): string {
  return new Intl.DateTimeFormat(NUMBER_LOCALE[locale] ?? "ru-RU", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(iso));
}
